import DeviceTelemetryPage from './device-telemetries-page';

export default DeviceTelemetryPage;